<template>
  <div id="betaserc-m3-app">
    <div class="app-wrapper" :class="{['app-wrapper--' + step]: step, ['app-wrapper--path-opened']: !opened && isMobile }">
      <transition name="step">
        <div class="step-container" v-show="step !== 'path' && step !== 'start' && opened" :class="{['step-container--' + step]: step, 'step-container--animated': animated }">
          <div class="step-wrapper">
            <div class="close" @click="opened = false">
              <svg viewBox="0 0 19 9" width="19" height="9">
                <path fill="#FFF" fill-rule="evenodd" d="M18 5.6H6.6C7.4 6.9 7.8 7.8 8 9 5.9 7 3.2 5.8 0 4.8A19 19 0 008 .6a7.4 7.4 0 01-1.4 3.6H18v1.4z"/>
              </svg>
              <span>Назад</span>
            </div>
            <keep-alive>
              <component :is="step" :key="step + '_' + v" @step="openStep" @video="openVideo" @reset="resetApp" class="step" :class="'step--' + step" />
            </keep-alive>
          </div>
        </div>
      </transition>
      <transition name="intro">
        <start v-if="step === 'start'" v-model="step" class="start" />
      </transition>
      <map-path @step="openStep" :step="step" class="path" :key="'path_' + v" />
      <transition name="video">
        <div v-if="video" class="app-video-player">
          <div class="app-video-close" @click="video = null">
            <svg viewBox="0 0 16 16" width="24" height="24">
              <path fill="#fff" fill-rule="evenodd" d="M2.861 2.862c-2.833 2.833-2.833 7.443 0 10.277 2.834 2.833 7.444 2.833 10.277 0 2.834-2.834 2.834-7.445.001-10.278C10.305.027 5.695.028 2.861 2.862zm8.932 7.549l-1.382 1.383L8 9.383l-2.411 2.411-1.383-1.383L6.617 8 4.206 5.589l1.383-1.382L8 6.618l2.41-2.411 1.383 1.383L9.382 8l2.411 2.411z"/>
            </svg>
          </div>
          <video-player
            :playsinline="true"
            class="video-player-box"
            :class="{ 'app-video-test': video === 'test' }"
            :options="{
              aspectRatio: '16:9',
              sources: [{
                type: 'video/mp4',
                src: '/assets/videos/' + video + '.mp4'
              }]
            }"
          />
          <div v-if="video === 'test'" class="app-video-description">Оценка теста Хальмаги через 6 мес</div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
import Start from './components/start'
import MapPath from './components/map-path'
import Anamnesis from './components/anamnesis'
import Clarification from './components/clarification'
import Syndromes from './components/syndromes'
import Examination from './components/examination'
import Diagnosis from './components/diagnosis'
import Treatment from './components/treatment'
import Repeated from './components/repeated'
import 'video.js/dist/video-js.css'
import { mapState } from 'vuex'

export default {
  components: {
    videoPlayer,
    Start,
    MapPath,
    Anamnesis,
    Clarification,
    Syndromes,
    Examination,
    Diagnosis,
    Treatment,
    Repeated
  },
  data () {
    return {
      step: 'start',
      video: null,
      opened: true,
      animated: false,
      v: 0
    }
  },
  computed: {
    ...mapState({
      steps: state => state.steps
    }),
    pathVisible () {
      return this.isMobile && this.opened ? this.step === 'path' : this.step !== 'start'
    }
  },
  methods: {
    openStep (step) {
      const stepIndex = this.steps.findIndex(el => el.step === step)
      const curIndex = this.steps.findIndex(el => el.step === this.step)
      this.opened = false
      this.step = step
      this.animated = stepIndex > curIndex && step !== 'anamnesis'
      setTimeout(() => {
        this.opened = true
        if (this.isMobile) {
          this.$scrollTo('#betaserc-m3-app', 200, { offset: -60 })
        }
      }, this.animated ? 1000 : 50)
    },
    openVideo (video) {
      this.video = video
    },
    resetApp () {
      this.step = 'path'
      this.v = this.v + 1
    }
  }
}
</script>

<style lang="scss">
@import 'scss/global';

.app-video {
  &-player {
    position: absolute;
    left: 10px;
    right: 10px;
    top: 10px;
    bottom: 10px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, #0074b3, #002b70);
    border-radius: 16px;
    padding: 0 112px;

    @include media-down(md) {
      padding: 35px 0;
      top: 50%;
      bottom: auto;
      transform: translate(0, -50%);
    }

    .video-player {
      width: 100%;
    }
  }
  &-test {
    position: relative;
    top: -20px;

    @include media-down(md) {
      top: auto;
    }
  }
  &-description {
    position: absolute;
    color: #fff;
    left: 0;
    right: 0;
    text-align: center;
    font-weight: bold;
    bottom: 10px;
    font-size: 16px;
  }
  &-close {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
  }
}
.betaserc--m-3 {
  #betaserc-m3-app {
    background: url(./assets/bg.jpg);
    background-size: cover;
    margin: 0 0 16px;

    @include media-down(md) {
      background-image: url(./assets/bg-mobile.jpg);
      max-width: 480px;
      margin: 0 auto 16px;
      background-position: 20% top;
    }
  }
  .app-wrapper {
    padding-top: 48.25%;
    position: relative;

    @include media-down(md) {
      padding: 0;
    }
    &--path-opened,
    &--path {
      @include media-down(md) {
        padding-top: 162.5%;
      }
    }
    &--start {
      @include media-down(md) {
        padding-top: 50%;
      }
    }
  }

  .start,
  .path {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .step {
    background: #fff;
    border-radius: 0 1000px 1000px 0;
    height: 438px;
    padding: 20px 20px;
    width: 100%;
    position: relative;

    @include media-down(lg) {
      height: 360px;
      padding: 20px 0;
    }

    @include media-down(md) {
      height: auto;
      padding: 0;
    }

    h2 {
      font-size: 30px;
      color: #009cde;
      font-weight: 500;
      padding: 0;
      margin: 0;
      text-align: left;

      @include media-down(lg) {
        font-size: 22px;
      }
      @include media-down(md) {
        font-size: 20px;

        br {
          display: none;
        }
      }
    }
  }

  .step-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    backdrop-filter: blur(5px);
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;

    @include media-down(md) {
      position: relative;
      backdrop-filter: none;
      background: #fff;
    }
  }
  .step-wrapper {
    position: relative;
    width: 100%;
    padding: 5px 70px 0 25px;

    @include media-down(md) {
      padding: 5px 10px;
    }

    .close {
      position: absolute;
      left: 25px;
      bottom: 100%;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      font-weight: normal;

      @include media-down(md) {
        color: #fff;
        background: #0054a6;
        position: fixed;
        bottom: 0;
        z-index: 2;
        left: 0;
        width: 50%;
        height: 40px;
        padding: 12px 0 0 20px;
      }

      svg {
        margin: 0 10px 0 0;
      }

      span {
        text-decoration: underline;
      }
    }
  }
  .intro-leave {
    opacity: 1;
  }
  .intro-leave-to {
    opacity: 0;
    transition: all .3s;
  }
  .step-enter {
    opacity: 0;
  }
  .step-enter-to {
    opacity: 1;
    transition: all .3s;
  }
}
</style>
